import React, { Component, Fragment } from "react";
import { Trans, withTranslation } from "react-i18next";
import axios from "axios";
import isEmpty from "lodash.isempty";
import i18n from "../../../../i18n";
import { route } from "../../../../routes";
import {
  Form,
  FormHeader,
  FormFooter,
  FormBack,
  FormSubmit,
  Button,
  ResultsCounter,
  Actions,
  ButtonSecondary,
  Table,
  CheckboxElement,
  Link,
  withVenuesApi,
  withCourseContactApi,
  AutocompleteTextfieldApiElement,
} from "cw-styleguide-react";
import withAssets from "../../../../components/hoc/withAssets";
import { STEP_SESSION_CONTACT, STEP_SESSION_VIEW } from "../../../../constants";
import CoursesSessionsFormProgress from "../CoursesSessionsFormProgress";
import ErrorNavigation from "../../../../components/ErrorNavigation";

class SessionsVenuesStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedVenues: new Set(),
    };

    this.handleAddVenue = this.handleAddVenue.bind(this);
    this.handleSelectVenue = this.handleSelectVenue.bind(this);
    this.handleRemoveVenues = this.handleRemoveVenues.bind(this);
  }

  handleAddVenue(e) {
    e.preventDefault();

    let venues = this.props.venues;

    if (!venues.some((venue) => venue.id === this.props.venueId)) {
      if (this.props.venueContactId) {
        Promise.all([
          axios.get(
            this.props.venuesApiGetEndpoint("venues_api_venues") +
              "/" +
              this.props.venueId,
            {
              headers: {
                "Accept-Language": i18n.language,
                "content-type": "application/json",
              },
              params: {
                "published": true
              }
            }
          ),
          axios.get(
            this.props.courseContactApiGetEndpoint(
              "course_contact_api_contacts"
            ) +
              "/" +
              this.props.venueContactId,
            {
              headers: {
                "Accept-Language": i18n.language,
                "content-type": "application/json",
              },
              params: {
                "published": true
              }
            }
          ),
        ])
          .then(async ([response1, response2]) => {
            let venue = response1.data[0];
            let venueContact = response2.data[0];

            venue.contact = venueContact;

            venues.push(venue);

            this.props.handleSet({
              venues: venues,
              venueId: "",
              venueLabel: "",
              venueContactId: "",
              venueContactLabel: "",
            });
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        axios
          .get(
            this.props.venuesApiGetEndpoint("venues_api_venues") +
              "/" +
              this.props.venueId,
            {
              headers: {
                "Accept-Language": i18n.language,
                "content-type": "application/json",
              },
              params: {
                "published": true
              }
            }
          )
          .then((response) => {
            let venue = response.data[0];

            venue.contact = {};

            venues.push(venue);

            // this.props.handleSet('venues', venues);
            this.props.handleSet({
              venues: venues,
              venueId: "",
              venueLabel: "",
              venueContactId: "",
              venueContactLabel: "",
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }

  handleSelectVenue(e) {
    const selectedVenues = this.state.selectedVenues;
    const selectedVenueId = e.target.value;

    if (selectedVenues.has(selectedVenueId)) {
      selectedVenues.delete(selectedVenueId);
    } else {
      selectedVenues.add(selectedVenueId);
    }

    this.setState(selectedVenues);
  }

  handleRemoveVenues(e) {
    e.preventDefault();

    const selectedVenues = this.state.selectedVenues;

    let venues = this.props.venues;

    venues = venues.filter((venue) => !selectedVenues.has(venue.id));

    this.props.handleSet("venues", venues);

    selectedVenues.clear();

    this.setState(selectedVenues);
  }

  render() {
    const newSessionTitle = this.props.t(
      "local:view.courses.create.tabs.sessions.step.venues.title"
    );
    const existingSessionTitle =
      newSessionTitle +
      ": " +
      this.props.t("local:misc.session") +
      " " +
      this.props.sessionId;

    return (
      <Form multi={true}>
        <ErrorNavigation
          field={this.props.errorActiveField}
          index={this.props.sessionId}
          handleClearActiveErrors={this.props.handleClearActiveErrors}
        />
        <CoursesSessionsFormProgress
          step={this.props.step}
          handleSetStep={this.props.handleSetStep}
          isEditing={!!this.props.loadedSessionUuid}
        />
        <FormHeader
          title={this.props.sessionId ? existingSessionTitle : newSessionTitle}
          introduction={this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.introduction"
          )}
        />

        {/* Add venue */}
        <div id={"sessions." + this.props.sessionId + ".venues.1.id"} />
        <AutocompleteTextfieldApiElement
          key={"venue" + this.props["venueLabel"]}
          size={"large"}
          name={"venue"}
          label={this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.field.addVenue.label"
          )}
          placeholder={this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.field.addVenue.placeholder"
          )}
          description={this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.field.addVenue.description"
          )}
          advancedDescription={{
            link: {
              text: this.props.t(
                "local:view.courses.create.tabs.sessions.step.venues.field.addVenue.advancedDescription.text"
              ),
            },
            body: (
              <Trans
                i18nKey={
                  "local:view.courses.create.tabs.sessions.step.venues.field.addVenue.advancedDescription.body"
                }
                components={[
                  <Link to={route("venuesManage")} target={"_blank"} />,
                ]}
              />
            ),
          }}
          api={this.props.venuesApiGetEndpoint("venues_api_venues_mq")}
          authorize={true}
          dataFields={["venueName", "townCity", "postCode"]}
          queryParameter={"search"}
          // additionalParameters={{
          //   "atlasAccountId": this.props.values.mainProviderId
          // }}
          keyField={"venueId"}
          valueField={"venueName"}
          keyword={this.props["venueLabel"]}
          acceptLanguage={i18n.language}
          value={this.props["venueId"]}
          errors={
            this.props.errors[
              "sessions." + this.props.sessionId + ".venues.1.id"
            ]
          }
          onChange={this.props.handleChange}
        />

        {/* Add contact to venue */}
        <AutocompleteTextfieldApiElement
          key={"venueContact" + this.props["venueContactLabel"]}
          size={"large"}
          name={"venueContact"}
          label={this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.field.addContactToVenue.label"
          )}
          placeholder={this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.field.addContactToVenue.placeholder"
          )}
          description={this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.field.addContactToVenue.description"
          )}
          advancedDescription={{
            link: {
              text: this.props.t(
                "local:view.courses.create.tabs.sessions.step.venues.field.addContactToVenue.advancedDescription.text"
              ),
            },
            body: (
              <Trans
                i18nKey={
                  "local:view.courses.create.tabs.sessions.step.venues.field.addContactToVenue.advancedDescription.body"
                }
                components={[
                  <Link to={route("contactsManage")} target={"_blank"} />,
                ]}
              />
            ),
          }}
          api={this.props.courseContactApiGetEndpoint(
            "course_contact_api_contacts_mq"
          )}
          authorize={true}
          dataFields={["contactName", "email", "telephoneNumber"]}
          queryParameter={"search"}
          additionalParameters={{
            atlasAccountId: this.props["mainProviderId"],
          }}
          keyField={"id"}
          valueField={"contactName"}
          keyword={this.props["venueContactLabel"]}
          acceptLanguage={i18n.language}
          value={this.props["venueContactId"]}
          errors={this.props.errors["venueContactId"]}
          onChange={this.props.handleChange}
        />

        <Button
          classes={["button", "button--style-blue"]}
          onClick={this.handleAddVenue}
          disabled={!this.props["venueId"]}
        >
          {this.props.t(
            "local:view.courses.create.tabs.sessions.step.venues.table.control.add"
          )}
        </Button>

        {this.props.venues.length > 0 && (
          <Fragment>
            <ResultsCounter count={this.props.venues.length}>
              <span>
                {this.props.t(
                  "local:view.courses.create.tabs.sessions.step.venues.table.entity"
                )}
              </span>
              <Actions>
                <ButtonSecondary
                  classes={["button--large"]}
                  onClick={this.handleRemoveVenues}
                >
                  {this.props.t(
                    "local:view.courses.create.tabs.sessions.step.venues.table.control.remove"
                  )}
                </ButtonSecondary>
              </Actions>
            </ResultsCounter>
            <Table
              headers={[
                this.props.t(
                  "local:view.courses.create.tabs.sessions.step.venues.table.header.select"
                ),
                this.props.t(
                  "local:view.courses.create.tabs.sessions.step.venues.table.header.venueName"
                ),
                this.props.t(
                  "local:view.courses.create.tabs.sessions.step.venues.table.header.townCity"
                ),
                this.props.t(
                  "local:view.courses.create.tabs.sessions.step.venues.table.header.postcode"
                ),
                this.props.t(
                  "local:view.courses.create.tabs.sessions.step.venues.table.header.contactName"
                ),
              ]}
              rows={this.props.venues.map((venue) => {
                return [
                  <CheckboxElement
                    checked={this.state.selectedVenues.has(venue.id)}
                    value={venue.id}
                    onChange={this.handleSelectVenue}
                  />,
                  <Link
                    to={
                      route("venuesManage") +
                      "/" +
                      route("venuesEdit", { venue: venue.id })
                    }
                    target={"_blank"}
                  >
                    {venue.name?.[this.props.inputLanguage] ||
                      venue.venueName?.[this.props.inputLanguage]}
                  </Link>,
                  venue.townCity[this.props.inputLanguage],
                  venue.postCode,
                  !isEmpty(venue.contact) ? (
                    <Link
                      to={
                        route("contactsManage") +
                        "/" +
                        route("contactsEdit", { contact: venue.contact.id })
                      }
                      target={"_blank"}
                    >
                      {venue.contact.name?.[this.props.inputLanguage] ||
                        venue.contact.contactName?.[this.props.inputLanguage]}
                    </Link>
                  ) : (
                    this.props.t("misc.none")
                  ),
                ];
              })}
            />
          </Fragment>
        )}

        <FormFooter>
          <FormBack
            onClick={(e) => {
              this.props.handleSetStep(e, STEP_SESSION_CONTACT);
              this.props.handleScrollTop();
            }}
          />
          <FormSubmit
            onClick={(e) => {
              this.props.handleSaveSession(e);
              this.props.handleSetStep(e, STEP_SESSION_VIEW);
              this.props.handleClearSession();
              this.props.handleScrollTop();
            }}
          >
            {this.props.t(
              "local:view.courses.create.tabs.sessions.step.venues.callToAction"
            )}
          </FormSubmit>
        </FormFooter>
        {this.props.sessions.length > 0 && (
          <FormFooter>
            <FormBack
              onClick={(e) => {
                this.props.handleSetStep(e, STEP_SESSION_VIEW);
                this.props.handleClearSession();
                this.props.handleScrollTop();
              }}
            >
              {this.props.t(
                "local:view.courses.create.tabs.sessions.callToAction"
              )}
            </FormBack>
          </FormFooter>
        )}
      </Form>
    );
  }
}

export default withVenuesApi(process.env)(
  withCourseContactApi(process.env)(
    withAssets(withTranslation("local")(SessionsVenuesStep))
  )
);
